import App from "@/App.vue";

export default [
  {
    path: "/seguradoras",
    name: "insurance_company",
    component: App,
    redirect: { name: "list insurance_company" },
    children: [
      {
        path: "",
        name: "list insurance_company",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ListInsuranceCompany.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Seguradoras",
              disabled: false,
              link: false,
              to: { name: "insurance_company" }
            }
          ],
          displayName: "Lista Seguradoras - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_seguradora"
        }
      },
      {
        path: "/nova-seguradora",
        name: "new insurance_company",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewInsuranceCompany.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Adicionar Seguradora",
              disabled: false,
              link: true,
              to: { name: "insurance_company" }
            }
          ],
          displayName: "Adicionar Seguradora - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_seguradora"
        }
      },
      {
        path: "/seguradora/:id",
        name: "edit insurance_company",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditInsuranceCompany.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Editar Seguradora",
              disabled: false,
              link: true,
              to: { name: "insurance_company" }
            }
          ],
          displayName: "Editar Seguradora - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_seguradora"
        }
      }
    ]
  }
];
